import type { AgendaEvent } from "@/api/db/agenda";
import type { AgendaStatusValue } from "@/api/db/connection";
import { AgendaLabels } from "@/lib/labels/agenda";
import { djs } from "@/lib/djs";

export const AgendaView = {
	isCancelled(status: AgendaStatusValue) {
		if (status === "cancelado") {
			return true;
		}

		if (status === "cancelado_remoto") {
			return true;
		}

		return false;
	},

	eventTitle(event: AgendaEvent) {
		if (event.bloqueio) {
			return AgendaLabels.tipo.Bloqueio;
		}

		if (event.patient !== null) {
			return event.patient.name;
		}

		return AgendaLabels.tipo[event.tipo];
	},

	week(today: string, offset: number) {
		const anchor = djs(today, "YYYY-MM-DD");
		const fromMonday = (anchor.day() + 6) % 7;
		const monday = anchor.subtract(fromMonday, "day").add(offset * 7, "day");

		const days = Array.from({ length: 7 }, (_, index) =>
			monday.add(index, "day").format("YYYY-MM-DD"),
		);

		return { de: monday.format("YYYY-MM-DD"), ate: monday.add(6, "day").format("YYYY-MM-DD"), days };
	},
};
